<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="50%"
    :before-close="close">
    <QuickNote :customerId="customerId" :contactId="contactId" :note="note" :noteId="noteIdToEdit" @close="close"></QuickNote>
  </el-dialog>
</template>
<script>

import QuickNote from '@/components/Quick-note-component'

export default {
	name: 'QuickNoteModal',
	props: {
    note : {
      type : Object
    },
    visible : Boolean,
    customerId : {
      type:String,
      default: null,
    },
    contactId : {
      type:String,
      default: null,
    }
  },
	components : {
    QuickNote,
	},
	data() {
		return {
      fkId: null,
		}
	},
	computed : {
    noteIdToEdit (){
      return _.get(this.note, 'id');
    },
    title (){
      if (this.note == null) {
        return this.$i18n.t('clients.newNote');
      }
      return this.$i18n.t('clients.editNote');
    },
  },
	methods : {
    close (){
      this.$emit('close');
    },
    save (){

    },
  },
  created(){

  }
}
</script>
<style lang="scss">
@import '../assets/scss/_variables';

.el-form{
  margin:20px;margin-right:40px;
}

.add-note-button{
  float:right;
}
.quill-editor {
  .ql-toolbar.ql-snow {
    //border: none;
    //background: lighten($background-color, 2%);
    //border-bottom: 1px solid $background-color;
  }
  .ql-container.ql-snow {
    //border: none;
    height:150px;
  }
}

@media (max-width: 768px) {
  .el-form{
    margin:0px;
  }
  .add-note-button{
    position:relative;
    float:none;
    width:100%;
    margin-top:20px;
  }
  .el-upload{
    width:100%;
  }
  .add-attachment-button{
    position:relative;
    float:none;
    width:100%;
  }
}

</style>
